import { Modal } from "@mui/material";
import styled from "styled-components";

const ModalCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 632px;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 8px;
    border: 1px solid rgb(144, 144, 144);
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);

    @media (max-width: 800px) {
        margin-right: 16px;
        width: calc(100% - 32px);
    }
`;

const CustomizedTitle = styled.div`
    color: #000;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -0.96px;
    margin-bottom: 30px;
`;

const Line = styled.div`
  border: none;
  height: 10px;
  border-bottom: 2px solid #57c4c2;
  width: 96px;
`;

const TitleBreak = styled.br`
    display: none;

    @media (max-width: 800px) {
        display: block;
    }
`;

const ModalClose = styled.img`
    position: absolute;
    right: 40px;
    top: 40px;
    cursor: pointer;
    z-index: 10;
    width: 24px;
    height: 24px;
`;

const ModalContent = styled.div`
    display: flex;
    padding: 40px;
`;

const Content = styled.div`
    flex: 1;
`;

const Text = styled.p`
    color: #181122;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 133%;
    letter-spacing: -0.28px;
    margin-bottom: 24px;
`;

const BoxBlue = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 16px;
    border-radius: 8px;
    border: 1px solid #463794;
    background: #463794;
    margin-bottom: 8px;
    width: 100%;
`;

const TextBoxBlue = styled.p`
    color: #FFF;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const HighlightedTextBoxBlue = styled.p`
    color: #FFF;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
`;

const SubTitleBoxBlue = styled.p`
    color: #FFF;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const BoxPrice = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 8px;
    row-gap: 8px;
    margin: 0px;
    width: 100%;
    margin-bottom: 10px;

    @media (max-width: 800px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const Card = styled.div`
    min-height: 98px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    background: #FFF;
    padding: 8px;
`;

const Title = styled.p`
    color: #000;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const BoxHighlightedText = styled.div`
    display: flex;
    align-items: center;
`;

const HighlightedTextCard = styled.p`
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin-top: 16px;
`;

const TextCard = styled.p`
    color: #999;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
`;

const CardLink = styled.div`
    position: relative;
    min-height: 98px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 1px solid #E3E3E3;
    background: #F1F1F1;
    padding: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    &:hover {
        border: 1px solid #473694;
    }
`;

const TextCardLink = styled.p`
    color: #473694;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
`;

const ButtonLink = styled.img`
    position: absolute;
    right: 8px;
    top: 8px;
`;

const ModalUpdatePlan = ({ showModal, setShowModal }) => {

    const data = [
        {
            title: "De 4 a 9 usuários",
            price: "19",
            hasLink: false,
        },
        {
            title: "De 10 a 19 usuários",
            price: "49",
            hasLink: false,
        },
        {
            title: "De 20 a 49 usuários",
            price: "109",
            hasLink: false,
        },
        {
            title: "De 50 a 79 usuários",
            price: "209",
            hasLink: false,
        },
        {
            title: "De 80 a 99 usuários",
            price: "249",
            hasLink: false,
        },
        {
            title: "+ de 100 usuários",
            price: "Sob consulta",
            hasLink: true,
        }
    ]

    return (
        <Modal
            open={showModal}
            onClose={() => {
                setShowModal(false);
            }}
        >
            <ModalCenter style={{ overflowY: "auto", maxHeight: "95%", padding: 0, border: 0 }}>
                <ModalClose
                    src="/img/modal_close.svg"
                    onClick={() => setShowModal(false)}
                />
                <ModalContent>
                    <Content>
                        <CustomizedTitle>Atualize seu plano<TitleBreak /> à partir de janeiro <Line /></CustomizedTitle>
                        <Text>
                            Em 01 de janeiro de 2026 o Zag passará a operar com uma nova política de preços. À partir de janeiro faça o upgrade ou opte por continuar utilizando o Zag gratuitamente com até 3 usuários.
                        </Text>
                        <BoxBlue>
                            <TextBoxBlue>Até 3 usuários</TextBoxBlue>
                            <div>
                                <HighlightedTextBoxBlue>Gratuito</HighlightedTextBoxBlue>
                                <SubTitleBoxBlue>/sem limites de uso</SubTitleBoxBlue>
                            </div>
                        </BoxBlue>
                        <BoxPrice>
                            {data?.map((item, index) => {
                                if (item.hasLink) {
                                    return (
                                        <CardLink key={index} onClick={() => window.open('mailto:oi@zagapp.com.br', '_blank')}>
                                            <div>
                                                <Title>{item.title}</Title>
                                                <BoxHighlightedText style={{ paddingTop: 4 }}>
                                                    <HighlightedTextCard style={{ fontSize: 18 }}>{item.price}</HighlightedTextCard>
                                                </BoxHighlightedText>
                                            </div>
                                            <TextCardLink>Fale com o nosso time</TextCardLink>
                                            <ButtonLink src='/img/linkBlackFriday.svg' alt='Ícone link' />
                                        </CardLink>
                                    )
                                } else {
                                    return (
                                        <Card key={index}>
                                            <Title>{item.title}</Title>
                                            <BoxHighlightedText>
                                                <HighlightedTextCard style={{ fontSize: 12, paddingRight: 2 }}>R$</HighlightedTextCard>
                                                <HighlightedTextCard style={{ fontSize: 24 }}>{item.price}</HighlightedTextCard>
                                                <HighlightedTextCard style={{ fontSize: 16 }}>,90</HighlightedTextCard>
                                            </BoxHighlightedText>
                                            <TextCard>/por mês</TextCard>
                                        </Card>
                                    )
                                }
                            })}
                        </BoxPrice>
                    </Content>
                </ModalContent>
            </ModalCenter>
        </Modal>
    );
}

export default ModalUpdatePlan;
